// language=GraphQL
export const ALL_ITINERARIES_QUERY = `query Query($withItems: Boolean = false, $withItemsImage: Boolean = false, $withItemsMapMarkers: Boolean = false) {
  itineraries: itineraries {
    id
    items @include(if: $withItems) {
      id
      duration
      title
      text
      image @include(if: $withItemsImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mapMarkers @include(if: $withItemsMapMarkers) {
        id
        lat
        lng
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_ITINERARY_QUERY = `query Query($id: ID!, $withItems: Boolean = false, $withItemsImage: Boolean = false, $withItemsMapMarkers: Boolean = false) {
  itinerary: itinerary(id: $id) {
    id
    items @include(if: $withItems) {
      id
      duration
      title
      text
      image @include(if: $withItemsImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mapMarkers @include(if: $withItemsMapMarkers) {
        id
        lat
        lng
      }
    }
  }
}`

// language=GraphQL
export const CREATE_ITINERARY_MUTATION = `
  mutation Mutation($input: CreateItineraryInput, $withItems: Boolean = false, $withItemsImage: Boolean = false, $withItemsMapMarkers: Boolean = false) {
    itinerary: createItinerary(input: $input) {
      id
      items @include(if: $withItems) {
        id
        duration
        title
        text
        image @include(if: $withItemsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mapMarkers @include(if: $withItemsMapMarkers) {
          id
          lat
          lng
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_ITINERARY_MUTATION = `
  mutation Mutation($input: UpdateItineraryInput, $withItems: Boolean = false, $withItemsImage: Boolean = false, $withItemsMapMarkers: Boolean = false) {
    itinerary: updateItinerary(input: $input) {
      id
      items @include(if: $withItems) {
        id
        duration
        title
        text
        image @include(if: $withItemsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mapMarkers @include(if: $withItemsMapMarkers) {
          id
          lat
          lng
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_ITINERARY_MUTATION = `
  mutation Mutation($input: DeleteItineraryInput) {
    deleteItinerary(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ITINERARY_MUTATION = `
  mutation Mutation($input: DeleteItineraryInput) {
    forceDeleteItinerary(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_ITINERARY_ITEMS_MUTATION = `
  mutation Mutation($input: addItineraryItemsInput) {
    addItineraryItems(input: $input) {
      id
      itemIds
    }
  }`

// language=GraphQL
export const REMOVE_ITINERARY_ITEMS_MUTATION = `
  mutation Mutation($input: removeItineraryItemsInput) {
    removeItineraryItems(input: $input) {
      id
      itemIds
    }
  }`

// language=GraphQL
export const CREATE_ITINERARY_ITEMS_MUTATION = `
  mutation Mutation($input: createItineraryItemsInput) {
    createItineraryItems(input: $input) {
      id
      itemIds
    }
  }`

// language=GraphQL
export const DELETE_ITINERARY_ITEMS_MUTATION = `
  mutation Mutation($input: deleteItineraryItemsInput) {
    deleteItineraryItems(input: $input) {
      id
      itemIds
    }
  }`

// language=GraphQL
export const UPDATE_ITINERARY_ITEMS_ORDER_MUTATION = `
  mutation Mutation($input: updateItineraryItemsOrderInput) {
    updateItineraryItemsOrder(input: $input) {
      id
      itemIds
    }
  }`

// language=GraphQL
export const ITINERARIES_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false) {
  groupedDependents: itineraryDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency
    }
  }
}`
